import NoGiftsIcon from "@/assets/icons/no-gifts-inventory-icon.svg?react"

import { useI18n } from "@/shared/i18n"

import { getGiftRelayBotHandle } from "../lib/relayBot"

interface InventoryEmptyStateProps {
  onHandleClick?: () => void
}

export function InventoryEmptyState({
  onHandleClick,
}: InventoryEmptyStateProps) {
  const { t } = useI18n()
  const handle = getGiftRelayBotHandle()
  const body = t("inventory.empty.body").replace("{handle}", handle)
  const idx = body.indexOf(handle)
  const before = idx === -1 ? body : body.slice(0, idx)
  const after = idx === -1 ? "" : body.slice(idx + handle.length)

  return (
    <div className="flex w-full flex-col items-center gap-4 px-8 pt-20 text-center">
      <NoGiftsIcon className="size-[60px] text-white" />
      <p className="max-w-[326px] text-[16px] font-medium leading-[19px] tracking-[-0.5px] text-white">
        {before}
        <button
          type="button"
          onClick={onHandleClick}
          className="text-[#00FE74] hover:underline focus:outline-none"
        >
          {handle}
        </button>
        {after}
      </p>
    </div>
  )
}
